import { Outlet, Navigate, useNavigate, useLocation } from "react-router-dom";
import jwt_decode from "jwt-decode";

//Global State using JOTAI
import { useAtom } from "jotai";
import { gbState } from "../../components/shared/GlobalState";


const PrivateRoutes = (props) => {
  let navigate = useNavigate();
  let location = useLocation();
  const [{ user }] = useAtom(gbState);

  // Don't attempt to decode token on login/public pages
  if (location.pathname === "/login" || location.pathname === "/") {
    return <Outlet />;
  }

  let usrDetails = null;
  try {
    const token = localStorage.getItem("token");
    if (token) {
      usrDetails = jwt_decode(token);
    }
  } catch (e) {
    // Invalid token — handled below
  }

  let currentUserRole = usrDetails?.role || null;

  if (!currentUserRole) {
    localStorage.removeItem("token");
  }

  let auth = { token: localStorage.getItem("token") };

  if (props.roleRequired && currentUserRole) {
    return auth.token ? (
      props.roleRequired.includes(currentUserRole) ? (          <Outlet />
      ) : (
        <Navigate to="/error403" />
      )
    ) : (
      <Navigate to="/login" />
    );
  } else {
    return <Navigate to="/login" />;
  }
};
PrivateRoutes.defaultProps = {
  roleRequired: ["ADMIN", "CONSULTANT"],
};

export default PrivateRoutes;
